export default "https://cdn-static.gokick.com/assets/7e5886a8604a8a782ca6a0de4eecb197b7d69c39/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";